import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

import { SpanishRegulatoryHelperService } from '@frontend/promo-homewidget';
import { Subject, takeUntil } from 'rxjs';

@Directive({
    selector: '[grayoutStyle]',
    standalone: true,
})
export class GrayoutStyleDirective implements OnInit, OnDestroy {
    @Input() isDisabled: boolean = true;

    private readonly _destroy$ = new Subject<void>();

    constructor(
        private spanishRegulatoryHelperService: SpanishRegulatoryHelperService,
        private elementRef: ElementRef,
    ) {}

    ngOnInit() {
        this.spanishRegulatoryHelperService.reasonCodes$.pipe(takeUntil(this._destroy$)).subscribe((reasonCodes: string[]) => {
            if (reasonCodes?.length > 0 && this.spanishRegulatoryHelperService.evaluateIfPlayerIsRisky(reasonCodes) && this.isDisabled) {
                this.elementRef.nativeElement.classList.add('grayscale');
            }
        });
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
